export default "__VITE_ASSET__429830d9__"